import ItemComponent from './Item/Item'
import FiltersComponent from '../../../../Filters/Filters'

export const Item = ItemComponent
export const Filters = FiltersComponent